import { Component } from '@angular/core';

@Component({
  selector: 'app-botiquin-empresarial-hero',
  standalone: true,
  imports: [],
  templateUrl: '../../hero-empresarial/hero-empresarial.component.html',
  styleUrl: './botiquin-empresarial-hero.component.css'
})
export class BotiquinEmpresarialHeroComponent {
  name="Botiquín Empresarial";
  description = "Gestión integral de botiquines empresariales, asegurando su abastecimiento, actualización y cumplimiento normativo para garantizar la seguridad y bienestar en tu empresa.";
  description2 = "";
  routeLogo = "assets/img/enterprise/menu/botiquinEmpresarial.svg";
  routeImage = "assets/img/enterprise/hero/fotoBotiquinEmpresarial.svg"
}
